export const primaryGreen = "#2C6057";
export const lightGreen = "#5B8D27";
export const orange = "#F47421";
export const yellow = "#FECC46";

export const collarLink = "https://app.collar.pet/brands/muttleys-doggy-daycare/book/";

export const facebookLink = "https://www.facebook.com/muttleysdogsdaycare/";
export const instagramLink = "https://www.instagram.com/muttleysdoggydaycare/";
